import { useEffect, useRef } from 'react';

type Props = {
  slot: string;
  className?: string;
  format?: 'auto' | 'horizontal' | 'rectangle';
  placeholder?: string;
};

type AdSenseWindow = Window & {
  adsbygoogle?: Array<Record<string, unknown>>;
};

export default function AdSlot({ slot, className = '', format = 'auto', placeholder }: Props) {
  const requested = useRef(false);

  useEffect(() => {
    if (requested.current) return;
    requested.current = true;

    try {
      const adsWindow = window as AdSenseWindow;
      adsWindow.adsbygoogle = adsWindow.adsbygoogle || [];
      adsWindow.adsbygoogle.push({});
    } catch (error) {
      console.error('AdSense ad request failed', error);
    }
  }, []);

  return (
    <div className={`adSlot ${className}`.trim()}>
      {placeholder && <span className="adPlaceholder">{placeholder}</span>}
      <ins
        className="adsbygoogle"
        style={{ display: 'block' }}
        data-ad-client="ca-pub-3077165283705361"
        data-ad-slot={slot}
        data-ad-format={format}
        data-full-width-responsive="true"
      />
    </div>
  );
}
